<!-- =========================================================================================
    File Name: ArchiveList.vue
    Description: Add functionality on selecting row
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
  <vx-card>
      <div class="p-6">
        <div class="vx-col w-full">
          <div class="mb-4 flex flex-wrap justify-between">
            <div class="flex w-2/3 h-12">
              <vs-input class="mr-4" v-model="keyword" placeholder="" @keyup.enter="onSearch"/>
              <vs-select class="mr-4 mb-4" v-model="searchType" name="item-searchType">
                <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in searchTypeOptions" />
              </vs-select>
              <vs-button color="primary" type="border" icon-pack="feather" icon="icon-search" @click="onSearch"></vs-button>
            </div>
            <div class="flex w-1/3 justify-end">
            <vs-button class="" @click="onAdd">글 추가</vs-button>
            </div>
          </div>
        </div>

        <vue-good-table
          mode="remote"
          isLoading.sync="isLoading"
          @on-page-change="onPageChange"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-row-click="onRowClick"
          :pagination-options="{
            enabled: true,
            dropdownAllowAll: false,
            nextLabel: '',
            prevLabel: '',
            rowsPerPageLabel: '',
            perPage: 20
          }"
          :sort-options="{
            enabled: true,
            //initialSortBy: {field: 'boardName', type: 'asc'}
          }"
          :columns="columns"
          :rows="rows"
          :totalRows="totalRecords"
          :fix-header="true"
          :line-numbers="false"
          styleClass="vgt-table condensed"
          />
      </div>
    </vx-card> 
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import { fetchData } from '@/api/module'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      isLoading: false,
      archive_data: null,
      columns: [
        {
          label: 'No.',
          field: 'boardEntrySeq',
          type: 'name'
        },
        {
          label: '제목',
          field: this.fieldFn,
          thClass: 'text-center',
          type: 'name',
          sortable: false
        },
        {
          label: '작성자',
          field: 'writerName',
          type: 'name'
        },
        {
          label: '작성일자',
          field: 'createDate',
          type: 'date',
          formatFn: this.createDate,
          dateInputFormat: 'yyyy-MM-dd',
          dateOutputFormat: 'yyyy-MM-dd'
        },
        {
          label: '조회수',
          field: 'hits',
          type: 'name'
        }
      ],
      rows: [],
      totalRecords: 0,
      searchType: 'Title',
      keyword: '',
      serverParams: {
        page: 1,
        perPage: 20,
        field: 'BoardEntrySeq',
        type: 'DESC',
        boardSeq: 2
      },
      searchTypeOptions: [
        {
          value: 'Title',
          text: '제목'
        },
        {
          value: 'WriterName',
          text: '작성자'
        },
        {
          value: 'Content',
          text: '내용'
        }
      ]
    }
  },
  methods: {
    fieldFn (rowObj) {
      return `${rowObj.title } [${rowObj.commentCnt}]`
    },
    createDate (value) {
      return value.split('T')[0]
    },

    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onAdd () {
      this.$router.push('/archive/archive-add')
    },

    onRowClick (params) {
      const boardEntrySeq = params.row.boardEntrySeq
      this.$router.push(`/archive/archive-view/${boardEntrySeq}`)
    },

    onPageChange (params) {
      this.serverParams.page = params.currentPage
      this.loadItems()
    },

    onPerPageChange (params) {
      this.serverParams.perPage = params.currentPerPage
      this.serverParams.page = 1
      this.loadItems()
    },

    onSortChange (params) {
      this.serverParams.field = params[0].field
      this.serverParams.type = params[0].type
      this.loadItems()
    },

    onSearch () {
      this.serverParams.searchType = this.searchType
      this.serverParams.keyword = this.keyword
      this.serverParams.page = 1
      this.loadItems()
    },

    async loadItems () { 
      try {
        const { data } = await fetchData('board', this.serverParams)
         
        this.totalRecords = data.count
        this.rows = data.list
      } catch (error) {
        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }    
    }
  },
  created () {
    this.loadItems()
  }
}
</script>
